import { render } from "./EliminarItemsModal.vue?vue&type=template&id=3c23e09b&scoped=true"
import script from "./EliminarItemsModal.vue?vue&type=script&lang=js"
export * from "./EliminarItemsModal.vue?vue&type=script&lang=js"

import "./EliminarItemsModal.vue?vue&type=style&index=0&id=3c23e09b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c23e09b"]])

export default __exports__